import { useMemo } from "react";
import { useWorkers } from "@/domains/workers/hooks/use-workers";
import { useAuthStore } from "@/lib/store/auth-enhanced";

/**
 * Hook to get the current user's worker information
 * Finds the worker associated with the current user
 */
export const useCurrentWorker = () => {
  const { user } = useAuthStore();
  const { workers, loading, error } = useWorkers({
    filters: { isActive: true },
  });

  const currentWorker = useMemo(() => {
    if (!user || !workers.length) return null;

    // Find the worker that matches the current user
    return workers.find((worker) => worker.userId === user.id) || null;
  }, [user, workers]);

  return {
    currentWorker,
    loading,
    error,
    isWorker: !!currentWorker,
  };
};
